import AddCircleIcon from "@material-ui/icons/AddCircle";
import AddIcon from "@material-ui/icons/Add";
import AssessmentIcon from "@material-ui/icons/Assessment";
import React from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useHistory } from "react-router-dom";

import SectionCard from "./SectionCard";
import classes from "./WelcomeSection.module.scss";

const WelcomeSection = () => {
  const history = useHistory();

  const handleSectionClick = (navigateUrl: string) => () => {
    sessionStorage.clear();
    history.push(navigateUrl);
  };

  return (
    <div className={classes.container}>
      <SectionCard
        icon={<AssessmentIcon />}
        title="Advertisers"
        description="Create, edit, and view Advertiser accounts."
        buttonTitle="Manage Advertisers"
        buttonIcon={<VisibilityIcon />}
        handleClick={handleSectionClick("/advertisers")}
      />

      <SectionCard
        icon={<AddCircleIcon />}
        title="ABM Campaign"
        description="Build an ABM campaign with our curated targeting options."
        buttonTitle="Add ABM Campaign"
        buttonIcon={<AddIcon />}
        handleClick={handleSectionClick("/campaigns/create/managed")}
      />

      <SectionCard
        icon={<AddCircleIcon />}
        title="Custom Campaign"
        description="Select your own bespoke targeting package"
        buttonTitle="Build a Campaign using custom targeting options"
        buttonIcon={<AddIcon />}
        handleClick={handleSectionClick("/campaigns/create/custom")}
      />
    </div>
  );
};

export default WelcomeSection;
